import {Component, EventEmitter, NgZone, OnInit, Output, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Vehicle} from '../../models/vehicle';
import {VehiclesHandlerService} from '../../api-handlers/vehicles-handler.service';
import {Travel} from '../../models/travel';
import {TravelsHandlerService} from '../../api-handlers/travels-handler.service';
import {SnackBarHandlerService} from '../../commons/snack-bar-handler.service';
import {AssignAvailableCarToUserComponent} from '../assign-available-car-to-user/assign-available-car-to-user.component';


@Component({
	selector: 'app-assign-car-to-user',
	templateUrl: './assign-car-to-user.component.html',
	styleUrls: ['./assign-car-to-user.component.css']
})
export class AssignCarToUserComponent implements OnInit {
	@ViewChild(AssignAvailableCarToUserComponent, { static: false }) assignAvailableCarToUserComponent: AssignAvailableCarToUserComponent;
	modalRef: BsModalRef;
	vehicleToSet: Vehicle;
	travelToApprove: Travel;
	@ViewChild('template', { static: false }) template;
	@Output() vehicleAssigned = new EventEmitter();
	selectedPlate: string ='';

	dom_elements = {
		assign_btn: {
			is_running: false,
			txt_run: 'ASSEGNAZIONE IN CORSO...',
			txt_not_run: 'ASSEGNA'
		}
	};

	mydataz = {
		vehicles: []
	};


	constructor(public vehiclesService: VehiclesHandlerService,
		public travelsHandlerService: TravelsHandlerService,
		public snackBarHandler: SnackBarHandlerService,
		private modalService: BsModalService, private ngZone: NgZone) { }

	ngOnInit() {
	}

	showDialog(travelToApprove: Travel) {
		this.travelToApprove = travelToApprove;
		this.vehicleToSet = new Vehicle(undefined);
		this.modalRef = this.modalService.show(this.template);
		this.selectedPlate ='';
	}

	onPlateChanged(value: string) {
		if (value) {
			let v = value.trim();
			v = v.replace(/ /g, '');
			this.vehiclesService.getVehicleByPlate(this.travelToApprove, v).then((vehicles: Vehicle[]) => {
				// this.vehicleToSet = vehicle;
				console.log(vehicles);
				this.ngZone.run(() => {
					this.mydataz.vehicles = vehicles;
					if (vehicles.length > 0) {
						this.vehicleToSet = vehicles[0];
					}
				});
			});
		}
	}

	vehicleSelected(vehicle: Vehicle) {
		this.vehicleToSet = vehicle;

	}

	setCarAndApprove() {
		this.dom_elements.assign_btn.is_running = true;

		if (this.vehicleToSet && this.vehicleToSet.id > 0) {
			this.travelToApprove.vehicle = this.vehicleToSet;
			this.travelsHandlerService.approveTravel(this.travelToApprove, this.vehicleToSet, false).then((travelNew: Travel) => {
				this.travelToApprove.status.id = travelNew.status.id;
				this.travelToApprove.status.name = travelNew.status.name;
				this.vehicleAssigned.next(undefined);
				this.modalRef.hide();
				this.dom_elements.assign_btn.is_running = false;
			}).catch(() => {

				this.snackBarHandler.showSnackbar('Attenzione impossibile assegnare auto. Verifica che l\'auto scelta sia libera per le date selezionate', 3000);

			}).then(() => {
				this.dom_elements.assign_btn.is_running = false;


			});
		} else {
			this.snackBarHandler.showSnackbar('Veicolo non selezionato', 3000);
			this.dom_elements.assign_btn.is_running = false;
		}
	}

	viewVehiclesAvailable(){
		this.assignAvailableCarToUserComponent.showDialog();
	}

	setVehicleFromAvailables(v: Vehicle){
		console.log("torno su prima dialog - veicolo impostato");
		console.log(v);
		this.onPlateChanged(v.plate);
		this.selectedPlate = v.plate;


	}
}
